<template>
  <div>
    <Form ref="formDynamic" :model="formDynamic" :label-width="350"
      style="width: 100%; max-height: 500px; overflow-y: auto;">
      <div v-for="item in data" :key="item.id">
        <FormItem :label="item.inventoryName + '/' + item.inventoryModel + ':'">
          <Select :label-in-value="true" @on-change="Selectdata($event, item.id)" v-model="item.facilityId"
            :filterable="true" style="width: 450px" placeholder="请选择关联设备">
            <Option v-for="val in deskList" :value="val.value" :key="val.value">
              {{ val.label }}
            </Option>
          </Select>
        </FormItem>
      </div>
      <FormItem>
        <Button type="primary" @click="handleSubmit()">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  props: {
    id: "",
  },
  data() {
    return {
      formDynamic: {},
      data: [],
      data2: [],
      deskList: [],
      deskId: "",
      facilityId: "",
      obj: {
        id: "",
        sysConsumableFacilityList: [],
      },
    };
  },
  async created() {
    await this.getInfo(this.id);
  },
  methods: {
    Selectdata(value, id) {
      this.data.forEach(item => {
        if (item.id === id) {
          item.facilityId = value.value;
          item.facilityName = value.label;
        }
      });
      this.obj.sysConsumableFacilityList = this.data;
    },
    async getInfo(id) {
      $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
        if (res && res.data) {
          let data = res.data;
          this.obj.id = data.id;
          this.deskId = data.deskId;
          this.data = data.sysConsumableFacilityList || [];
          this.OnDepartment();
        }
      });
    },
    async OnDepartment() {
      let q = {};
      let res = await $utils.api.load(
        "/admin/system/facility/getFacilityListOnly",
        q,
        "get"
      );
      let arr = res.rows;
      arr.map((item, index) => {
        let obj = {};
        obj.value = item.id;
        obj.label = item.facilityName + "/" + item.facilityType + "/" + item.assetNum;
        this.deskList.push(obj);
      });
    },
    async handleSubmit() {
      console.log(this.obj);
      if (this.obj.sysConsumableFacilityList == [] || this.obj.sysConsumableFacilityList.length === 0) {
        this.obj.sysConsumableFacilityList = this.data;
      }
      let res = await $utils.api.load(
        "/admin/system/receive/relevanceFacility",
        this.obj,
        "POST"
      );
      if (res.code == 200) {
        await $utils.toast.success("提交成功");
        setInterval(() => {
          $utils.url.go(0);
          this.$Modal.remove();
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
  },
};
</script>
